"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Yvonne = void 0;
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const Card_1 = require("../Card");
const CardType_1 = require("../CardType");
const ProductiveOutpost_1 = require("../colonies/ProductiveOutpost");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
class Yvonne extends Card_1.Card {
    constructor() {
        super({
            name: CardName_1.CardName.YVONNE,
            cardType: CardType_1.CardType.LEADER,
            metadata: {
                cardNumber: 'L25',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.opgArrow().text('GAIN ALL YOUR COLONY BONUSES TWICE');
                }),
                description: 'Once per game, gain all your colony bonuses twice.',
            },
        });
        this.isDisabled = false;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        if (player.game.gameOptions.coloniesExtension === false)
            return false;
        return this.isDisabled === false;
    }
    action(player) {
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
            ProductiveOutpost_1.ProductiveOutpost.giveAllColonyBonuses(player);
            ProductiveOutpost_1.ProductiveOutpost.giveAllColonyBonuses(player);
            this.isDisabled = true;
            return undefined;
        }));
        return undefined;
    }
}
exports.Yvonne = Yvonne;
//# sourceMappingURL=Yvonne.js.map